/** @format */

import PropTypes from 'prop-types';
import React from 'react';

export const Breadcrumbs = props => {
    const {crumbs, delimiter = '/', className} = props;

    return (
        <div
            className={`${className} breadcrumbs-34ks d-flex align-items-center justify-content-start color-accent-primary gap-1`}>
            {crumbs.map(({label, link, onClick}, index) => (
                <React.Fragment key={index}>
                    <div onClick={onClick} style={{cursor: onClick ? 'pointer' : 'default'}}>
                        {link ? <a href={link}>{label}</a> : <span>{label}</span>}
                    </div>
                    {index !== crumbs.length - 1 && <span>{delimiter}</span>}
                </React.Fragment>
            ))}
        </div>
    );
};

Breadcrumbs.propTypes = {
    crumbs: PropTypes.arrayOf(
        /** Pass a link or click event. Only one or the other */
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            link: PropTypes.string,
            onClick: PropTypes.func
        })
    ).isRequired,
    delimiter: PropTypes.string,
    className: PropTypes.string
};
